(() => {
  if (window.ukfcHeaderChatReady) return;
  window.ukfcHeaderChatReady = true;
  const desktop = matchMedia('(min-width: 768px)');
  let chat = null;
  let panel = null;
  let tools = null;
  let frame = 0;
  let position = { x: 0, y: 0 };
  let dragging = null;
  let resizeObserver = null;
  const buttons = () => [...document.querySelectorAll('[data-ukfc-header-chat]')];
  const status = document.createElement('p');
  status.className = 'visually-hidden';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  document.body.append(status);
  function findPanel() {
    const root = chat?.shadowRoot;
    return root?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part~="dialog"]') || root?.querySelector('[part~="dialog"]') || null;
  }
  function applyPosition() {
    chat?.style.setProperty('--ukfc-chat-x', position.x + 'px');
    chat?.style.setProperty('--ukfc-chat-y', position.y + 'px');
  }
  function placeTools() {
    if (!tools || !panel || !desktop.matches || !chat?.hasAttribute('open')) {
      if (tools) tools.hidden = true;
      return;
    }
    const r = panel.getBoundingClientRect();
    if (!r.width || !r.height) { tools.hidden = true; return; }
    const root = panel.getRootNode();
    if (!root.querySelector('[data-ukfc-chat-tools-style]')) {
      const style = document.createElement('style');
      style.setAttribute('data-ukfc-chat-tools-style', '');
      style.textContent = ".ukfc-chat-tools{position:absolute;top:0;left:0;display:flex;align-items:center;justify-content:space-between;width:100%;height:36px;box-sizing:border-box;padding:0 8px;background:#075b86;color:#fff;z-index:10;font:600 14px/1.2 var(--font-body-family,Arial,sans-serif)}.ukfc-chat-tools[hidden]{display:none!important}.ukfc-chat-move,.ukfc-chat-reset{min-height:32px;border:0;background:transparent;color:inherit;font:inherit;cursor:pointer}.ukfc-chat-move{flex:1;text-align:left;cursor:grab;touch-action:none}.ukfc-chat-move:active{cursor:grabbing}.ukfc-chat-reset{text-decoration:underline;padding-inline:8px}.ukfc-chat-move:focus-visible,.ukfc-chat-reset:focus-visible{outline:3px solid #f7cd2c;outline-offset:-3px}@media(max-width:767px){.ukfc-chat-tools{display:none!important}}";
      root.append(style);
    }
    if (tools.parentNode !== panel) panel.append(tools);
    tools.hidden = false;
  }
  function keepOnScreen() {
    if (!panel || !desktop.matches || !chat?.hasAttribute('open')) return;
    const r = panel.getBoundingClientRect();
    const dx = r.left < 8 ? 8 - r.left : r.right > innerWidth - 8 ? innerWidth - 8 - r.right : 0;
    const dy = r.top < 44 ? 44 - r.top : r.bottom > innerHeight - 8 ? innerHeight - 8 - r.bottom : 0;
    if (dx || dy) { position.x += dx; position.y += dy; applyPosition(); }
  }
  function sync() {
    frame = 0;
    const candidate = findPanel();
    if (candidate !== panel) {
      resizeObserver?.disconnect();
      panel = candidate;
      if (panel) { resizeObserver = new ResizeObserver(schedule); resizeObserver.observe(panel); }
    }
    const open = Boolean(chat?.hasAttribute('open'));
    buttons().forEach(b => b.setAttribute('aria-expanded', String(open)));
    keepOnScreen();
    placeTools();
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(sync); }
  function resetPosition() {
    position = { x: 0, y: 0 };
    const header = document.querySelector('.header__top');
    const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 80);
    const top = Math.min(Math.max(72, headerBottom + 44), Math.max(72, innerHeight - 260));
    chat?.style.setProperty('--ukfc-chat-top', top + 'px');
    applyPosition();
    schedule();
  }
  function createTools() {
    const b = buttons()[0];
    if (!b) return;
    tools = document.createElement('div');
    tools.className = 'ukfc-chat-tools';
    tools.hidden = true;
    const grip = document.createElement('button');
    grip.type = 'button';
    grip.className = 'ukfc-chat-move';
    grip.textContent = '⠿ ' + b.dataset.move;
    grip.setAttribute('aria-label', b.dataset.moveHelp);
    const reset = document.createElement('button');
    reset.type = 'button';
    reset.className = 'ukfc-chat-reset';
    reset.textContent = b.dataset.reset;
    reset.addEventListener('click', resetPosition);
    tools.append(grip, reset);
    grip.addEventListener('pointerdown', e => {
      if (e.button !== 0 || !panel || !desktop.matches) return;
      e.preventDefault();
      grip.focus({ preventScroll: true });
      const r = panel.getBoundingClientRect();
      dragging = { id: e.pointerId, clientX: e.clientX, clientY: e.clientY, x: position.x, y: position.y, rect: r };
      grip.setPointerCapture(e.pointerId);
      chat.setAttribute('data-ukfc-dragging', '');
    });
    grip.addEventListener('pointermove', e => {
      if (!dragging || e.pointerId !== dragging.id) return;
      const r = dragging.rect;
      const dx = Math.max(8 - r.left, Math.min(innerWidth - 8 - r.right, e.clientX - dragging.clientX));
      const dy = Math.max(44 - r.top, Math.min(innerHeight - 8 - r.bottom, e.clientY - dragging.clientY));
      position = { x: dragging.x + dx, y: dragging.y + dy };
      applyPosition();
      schedule();
    });
    const finish = () => { dragging = null; chat?.removeAttribute('data-ukfc-dragging'); schedule(); };
    grip.addEventListener('pointerup', finish);
    grip.addEventListener('pointercancel', finish);
    grip.addEventListener('lostpointercapture', finish);
    grip.addEventListener('keydown', e => {
      const moves = { ArrowLeft: [-1,0], ArrowRight: [1,0], ArrowUp: [0,-1], ArrowDown: [0,1] };
      if (!moves[e.key] || !desktop.matches) return;
      e.preventDefault();
      const step = e.shiftKey ? 40 : 10;
      position.x += moves[e.key][0] * step;
      position.y += moves[e.key][1] * step;
      applyPosition();
      schedule();
    });
  }
  function initialise() {
    const candidate = document.querySelector('shopify-chat');
    if (!candidate || !buttons().length || typeof candidate.show !== 'function') return false;
    if (candidate !== chat) {
      chat = candidate;
      chat.setAttribute('mode', 'standalone');
      chat.setAttribute('data-ukfc-header-ready', '');
      new MutationObserver(schedule).observe(chat, { attributes: true });
      const root = chat.shadowRoot;
      if (root) new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
      chat.addEventListener('transitionend', schedule);
      if (!tools) createTools();
      resetPosition();
    }
    schedule();
    return true;
  }
  async function openChat(button) {
    if (button.dataset.opening) return;
    button.dataset.opening = 'true';
    status.textContent = button.dataset.loading;
    try {
      const ready = customElements.whenDefined('shopify-chat').then(initialise);
      const timeout = new Promise(resolve => setTimeout(() => resolve(false), 10000));
      if (!await Promise.race([ready, timeout]) || !chat) throw new Error('Chat unavailable');
      resetPosition();
      chat.setAttribute('mode', 'standalone');
      chat.show();
      status.textContent = '';
      schedule();
    } catch {
      status.textContent = button.dataset.unavailable;
      const fallback = document.createElement('a');
      fallback.href = '/pages/contact';
      fallback.textContent = button.dataset.unavailable;
      fallback.className = 'ukfc-chat-fallback';
      document.querySelector('.ukfc-chat-fallback')?.remove();
      button.after(fallback);
    } finally { delete button.dataset.opening; }
  }
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-ukfc-header-chat]');
    if (!button) return;
    e.preventDefault();
    document.querySelector('.ukfc-chat-fallback')?.remove();
    if (chat?.hasAttribute('open') && typeof chat.close === 'function') { chat.close(); schedule(); return; }
    openChat(button);
  });
  window.addEventListener('resize', () => { if (!desktop.matches) position = { x: 0, y: 0 }; applyPosition(); schedule(); });
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('shopify-chat:close', () => { schedule(); buttons()[0]?.focus({ preventScroll: true }); });
  customElements.whenDefined('shopify-chat').then(initialise);
  initialise();
})();